import React, { useEffect, useState } from 'react';
import { isArray } from 'lodash';
import {
    Card,
    Form,
    Input,
    Upload,
    Button,
    message,
    Icon,
    Modal,
    Radio,
    Row,
    Col,
    Spin,
} from 'antd';
import { services } from '@comall-backend-builder/core';
import moment from 'moment';
import { errorHandle } from '../../services';
import './index.less';

const { Item: FormItem } = Form;

const Index = (props: { form: any }) => {
    const { form } = props;
    const { getFieldDecorator, setFieldsValue } = form;
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);
    const [clickType, setClickType] = useState<any>('');
    const [pictureUrl, setPictureUrl] = useState('');
    const [detail, setDetail] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const handlePreview = (file: any) => {
        setPreviewImage(file.thumbUrl || file.url);
        setPreviewVisible(true);
    };

    const handleChange = (e: any) => {
        if (e.file.status === 'done') {
            message.success('上传成功1个，上传失败0个');
            const cur = e.fileList[0] || {};
            if (cur?.response?.path) {
                setPictureUrl(cur?.response?.path);
            } else {
                setPictureUrl('');
            }
        } else if (e.file.status === 'error') {
            message.success('上传成功0个，上传失败1个，请重新上传!');
            setTimeout(() => {
                setFieldsValue({ pictureUrl: undefined });
                setFileList([]);
            }, 20);
        }
        setFileList(e.fileList);
        if (!(isArray(e.fileList) && e.fileList.length)) {
            setTimeout(() => {
                setFieldsValue({ pictureUrl: undefined });
                setPictureUrl('');
                setFileList([]);
            }, 20);
        }
    };

    // 查询甄币抽奖配置接口
    const handlePrizeUserPrize = () => {
        setLoading(true);
        services.api
            .get({}, { apiPath: `/prize/userPrize` })
            .then((res: any) => {
                const { link, pictureUrl, type } = res;
                setDetail(res);
                setClickType(type);
                if (pictureUrl) {
                    const fileListData = pictureUrl
                        ? [{ uid: '-1', status: 'done', url: pictureUrl }]
                        : [];
                    setFileList(fileListData);
                }
                setPictureUrl(pictureUrl);
                setFieldsValue({ link, pictureUrl, type });
            })
            .catch(errorHandle)
            .finally(() => {
                setTimeout(() => {
                    setLoading(false);
                }, 20);
            });
    };

    const handleSubmit = (e: { preventDefault: () => void }) => {
        e.preventDefault();
        form.validateFields((err: any, values: any) => {
            if (!err) {
                // 这里处理提交逻辑，包括使用上传的文件path
                const { link, type } = values;
                const params = {
                    pictureUrl,
                    link,
                    type,
                };
                services.api
                    .post(params, { apiPath: `/prize/userPrize/update` })
                    .then((res: any) => {
                        if (!!res.result) {
                            message.success('保存成功！');
                            handlePrizeUserPrize();
                        } else {
                            message.error(res.tip);
                        }
                    })
                    .catch(errorHandle);
            }
        });
    };

    const uploadButton = (
        <div>
            <Icon type="plus" />
            <div className="ant-upload-text">上传</div>
        </div>
    );

    const handleRadioChange = (e: any) => {
        setClickType(e.target.value);
    };

    useEffect(() => {
        handlePrizeUserPrize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="lottery-config">
            <Card title="甄币抽奖链接设置">
                <Spin spinning={loading}>
                    <div className="content-box">
                        <Form
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 12 }}
                            onSubmit={handleSubmit}
                        >
                            <FormItem label="移动端图片">
                                {getFieldDecorator('pictureUrl', {
                                    rules: [{ required: true, message: '请上传移动端图片' }],
                                })(
                                    <Upload
                                        accept="image/*"
                                        name="fileName"
                                        action={`${ENV.API_ROOT}/images`}
                                        listType="picture-card"
                                        fileList={fileList}
                                        onPreview={handlePreview}
                                        onChange={handleChange}
                                    >
                                        {fileList.length >= 1 ? null : uploadButton}
                                    </Upload>
                                )}
                                <div>最多上传1张，支持格式PNG、JPG、GIF</div>
                            </FormItem>
                            <Form.Item label="点击后">
                                {getFieldDecorator('type', {
                                    rules: [{ required: true, message: '请选择' }],
                                })(
                                    <Radio.Group onChange={handleRadioChange}>
                                        <Radio value={0}>按配置链接跳转</Radio>
                                        <Radio value={1}>显示错误提示“暂无活动”</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                            {clickType === 0 ? (
                                <FormItem label="落地链接">
                                    {getFieldDecorator('link', {
                                        rules: [{ required: true, message: '请输入移动端链接' }],
                                    })(<Input placeholder="输入内容" />)}
                                </FormItem>
                            ) : null}

                            <FormItem>
                                <Row>
                                    <Col offset={8} style={{ marginTop: 36 }}>
                                        <Button type="primary" htmlType="submit">
                                            保存设置
                                        </Button>
                                        <div>
                                            更新时间：
                                            {detail && detail.updateTime
                                                ? moment(detail.updateTime).format(
                                                      'YYYY-MM-DD HH:mm:ss'
                                                  )
                                                : detail && detail.createTime
                                                ? moment(detail.createTime).format(
                                                      'YYYY-MM-DD HH:mm:ss'
                                                  )
                                                : ''}
                                        </div>
                                    </Col>
                                </Row>
                            </FormItem>
                        </Form>
                    </div>
                </Spin>
            </Card>

            <Modal visible={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
                <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
        </div>
    );
};

export const LotteryConfig = Form.create({ name: 'lottery_config' })(Index);
